export default {
    CaptureList: require('./CaptureList').default,
    CaptureDetail: require('./CaptureDetail').default
}